export default {
  // Success messages
  publishSuccessTitle: {
    id: 'bo_seller.listings.actions.publish_success_title',
    defaultMessage: 'Success!',
  },
  publishSuccessContent: {
    id: 'bo_seller.listings.actions.publish_success_content',
    defaultMessage: 'Listing published successfully',
  },
  archiveSuccessTitle: {
    id: 'bo_seller.listings.actions.archive_success_title',
    defaultMessage: 'Success!',
  },
  archiveSuccessContent: {
    id: 'bo_seller.listings.actions.archive_success_content',
    defaultMessage: 'Listing archived successfully',
  },
  updateSuccessTitle: {
    id: 'bo_seller.listings.actions.update_success_title',
    defaultMessage: 'Success!',
  },
  updateSuccessContent: {
    id: 'bo_seller.listings.actions.update_success_content',
    defaultMessage: 'Listing updated successfully',
  },

  // Error messages
  errorTitle: {
    id: 'bo_seller.listings.actions.error_title',
    defaultMessage: 'Oops!',
  },
  fetchListingsErrorContent: {
    id: 'bo_seller.listings.actions.fetch_listings_error_content',
    defaultMessage: 'Failed to fetch listings. Please try again.',
  },
  fetchListingErrorContent: {
    id: 'bo_seller.listings.actions.fetch_listing_error_content',
    defaultMessage: 'Failed to fetch listing details. Please try again.',
  },
  publishErrorContent: {
    id: 'bo_seller.listings.actions.publish_error_content',
    defaultMessage: 'Failed to publish listing. Please try again.',
  },
  archiveErrorContent: {
    id: 'bo_seller.listings.actions.archive_error_content',
    defaultMessage: 'Failed to archive listing. Please try again.',
  },
  updateErrorContent: {
    id: 'bo_seller.listings.actions.update_error_content',
    defaultMessage: 'Failed to update listing. Please try again.',
  },
  winBackboxErrorContent: {
    id: 'bo_seller.listings.actions.win_backbox_error_content',
    defaultMessage: 'Failed to acquire backbox. Please try again.',
  },
  winAllBackboxesErrorContent: {
    id: 'bo_seller.listings.actions.win_all_backboxes_error_content',
    defaultMessage: 'Failed to acquire all backboxes. Please try again.',
  },
  setSalesMaximizerErrorContent: {
    id: 'bo_seller.listings.actions.set_sales_maximizer_error_content',
    defaultMessage: 'Failed to set sales maximizer price. Please try again.',
  },
  setSalesMaximizerAllErrorContent: {
    id: 'bo_seller.listings.actions.set_sales_maximizer_all_error_content',
    defaultMessage:
      'Failed to set sales maximizer prices for all markets. Please try again.',
  },
} as const
